import { gql } from "@urql/core";
import appConfig from "../utils/app-config";
import api, { clientRT, client } from "./api";

const getCompanySettingsQuery = `
  query {
    customPhrases {
      key
      value
    }
    settings {
      template
      usePrevCloseDayForMcap
      marketCap
      numberOfShare
      enablePDFDownload
      enableExcelDownload
      enablePrint
      showCookiePolicyInfo
      showTermsOfService
      showDataProviderInfo
      showDataDelayInfo
      timeZone
      googleAnalyticsEnabled
      useLatinNumbers
      styleURI
      tickerRefreshSeconds
      allowedParentDomains
      enabledDataItems {
        overView {
          name
          dataItems
        }
        groups {
          name
          dataItems
        }
      }
      instruments {
        id
        default
        ticker
        customTimezone
        shareName
        marketName
        currencyCode
        marketAbbreviation
        order
        isRT
        industry
      }
      format {
        shortDate
        longDate
        decimalDigits
        decimalSeparator
        thousandsSeparator
        negativeNumberFormat
        positiveNumberFormat
        positiveChangeFormat
      }
    }
  }
`;

export const getCompanySettings = () =>
  api.POST(window.appSettings.shareSeriesApiUrl, {
    query: getCompanySettingsQuery,
  })
    .then((data) => {
      // get all instrumentId which have realTime setting
      let realTimeId = [], noRealTimeId = [];
      const getRealtimeId = (data) => {
        data?.data?.settings?.instruments?.forEach(instrument => {
          if (instrument?.isRT) {
            realTimeId.push(instrument?.id);
          } else {
            noRealTimeId.push(instrument?.id);
          }
        });
      };

      getRealtimeId(data);
      const newSetting = { ...data, realTimeId: realTimeId, noRealTimeId: noRealTimeId };
      appConfig.set(newSetting);
      return newSetting;
    })
    .catch((error) => console.error("Error:", error));

const urlString = window.location.href;
const url = new URL(urlString);
const lang = url.searchParams.get("lang") || "en-GB";
const getTickerQuery = gql`
  query GetInstruments($ids: [Int!]!, $adjClose: Boolean, $toCurrency: String) {
    instruments: instrumentByIds(ids: $ids, exchangeCurrency: $toCurrency, adjClose: $adjClose) {
      instrumentId: id
      shareName
      currencyCode
      ticker: symbol
      marCat
      turnover
      market {
        marketAbbreviation: abbreviation
        translation {
          marketName: value
        }
        timezone{
          marketTimeZoneNameIANA: nameIANA
        }
        status {
          marketStatus: isOpened
        }
        closeTimeLocal
        openTimeLocal
      }
      currentPrice {
        lastUpdatedDate: date
        last
        change
        changePercentage
        volume
        high
        low
        bid
        ask
        bidSize
        askSize
        open
        prevClose
        vWAP: vwap
        todayTurnover
      }
      iSIN: isin
      fifty_two_weeks: performance(period: FIFTY_TWO_WEEKS) {
        high52W: highest
        low52W: lowest
        percent52W: changePercentage
        highestDate
        lowestDate
        closePrice52W: closePrice
      }
      ytd: performance(period: YTD) {
        highYTD: highest
        lowYTD: lowest
        yTD: changePercentage
        highestDate
        lowestDate
        closePriceYtd: closePrice
      }
      all: performance(period: ALL_TIME) {
        allTimeHigh: highest
        allTimeLow: lowest
        highestDate
        lowestDate
      }
      list (cultureName: "${lang}") {
        listName: name
      }
      subSector (cultureName: "${lang}"){
        industry: marCat
      }
      noShares
      lotSize
      lastDayIntraday(first: 99999) {
        totalTrades: totalCount
      }
      eps
    }
  }
`;

export const getTickers = async (toCurrency = null, adjClose = false) => {
  try {
    const responses = await Promise.allSettled([
      fetchTickers(toCurrency, adjClose, false),
      fetchTickers(toCurrency, adjClose, true)
    ]);

    const firstInstruments = responses[0]?.value?.data?.instruments || [];
    const secondInstruments = responses[1]?.value?.data?.instruments || [];

    return {
      data: {
        instruments: [...firstInstruments, ...secondInstruments]
      }
    };
  } catch (error) {
    console.error("Lỗi khi fetch tickers:", error);
    return { data: { instruments: [] } };
  }
};


const fetchTickers = async (toCurrency = null, adjClose = false, isRT = false) => {
  const { realTimeId, noRealTimeId } = appConfig.get();
  const activeClient = isRT ? clientRT : client;
  
  const response = await activeClient.executeQuery({ query: getTickerQuery, variables: {
    ids: isRT ? realTimeId : noRealTimeId,
    toCurrency,
    adjClose,
  } }).toPromise();
  return response;
}
